import { h } from "vue";
import type { IconSet, IconAliases } from "vuetify";
import { mdiIcons } from "./mdi";

const iconAliases: IconAliases = {
	collapse: "icon-chevron-up",
	complete: "icon-check-heavy",
	cancel: "icon-circle-slash",
	close: "icon-close-large",
	delete: "icon-close-small",
	clear: "icon-close-circle-stroke",
	calendar: "icon-calendar-check-stroke",
	success: "icon-check-circle",
	info: "icon-info-circle-stroke",
	warning: "icon-warning-triangle",
	error: "icon-warning-star",
	prev: "icon-chevron-left",
	next: "icon-chevron-right",
	sortAsc: "icon-chevron-up",
	sortDesc: "icon-chevron-down",
	checkboxOn: "icon-checkbox-marked-stroke",
	checkboxOff: "icon-checkbox-unmarked-stroke",
	checkboxIndeterminate: "icon-checkbox-marked-solid",
	delimiter: "icon-dots-vertical-more",
	sort: "icon-arrow-down-up",
	expand: "icon-chevron-down",
	menu: "icon-dots-horizontal-more",
	subgroup: "icon-chevron-down",
	dropdown: "icon-caret-down",
	radioOn: " icon-radio-filled",
	radioOff: "icon-radio-unfilled",
	edit: "icon-pencil-edit-stroke",
	eyeDropper: "icon-eye-stroke",
	ratingEmpty: "icon-star-rating-empty",
	ratingFull: "icon-star-rating-solid",
	ratingHalf: "icon-star-rating-half",
	loading: "icon-loading-dots-circle",
	first: "icon-chevron-left-end",
	last: "icon-chevron-right-end",
	unfold: "icon-unfold-more",
	file: "icon-file-blank-stroke",
	plus: "icon-plus-circle-stroke",
	minus: "icon-minus-circle-stroke",
	treeviewCollapse: "icon-chevron-up",
	treeviewExpand: "icon-chevron-down",
	upload: "icon-upload",
	color: "icon-palette",
	command: "icon-command",
	ctrl: "icon-control",
	space: "icon-space",
	shift: "icon-shift",
	alt: "icon-alt",
	enter: "icon-enter",
	arrowup: "icon-arrow-up",
	arrowdown: "icon-arrow-down",
	arrowleft: "icon-arrow-left",
	arrowright: "icon-arrow-right",
	backspace: "icon-backspace"
};

const LiveswitchIcon = {
	props: {
		icon: { type: String, required: true },
		tag: { type: String, default: "i" }
	},
	render(this: { icon: string; tag: string }) {
		const iconName = this.icon;

		if (iconName.startsWith("mdi-")) {
			const path = mdiIcons[iconName];
			if (!path) {
				console.warn(`Unknown MDI icon: ${iconName}. Add it to src/iconsets/mdi.ts.`);
				return h("i");
			}
			// Wrap the svg glyph in the same element root as font icons so fallthrough classes
			// (e.g. the 24px .status-icon disc background) land on a styleable root, not on the
			// bare svg whose inline 1em sizing would shrink the disc to a tiny glyph (LSP-16421).
			return h(this.tag, [
				h(
					"svg",
					{
						xmlns: "http://www.w3.org/2000/svg",
						viewBox: "0 0 24 24",
						role: "img",
						style: "fill: currentColor; width: 1em; height: 1em; font-size: inherit;"
					},
					[h("path", { d: path })]
				)
			]);
		}

		// Default: class-based icon
		return h(this.tag, { class: iconName });
	}
};

const liveswitchIconSet: IconSet = {
	component: LiveswitchIcon
};
export { iconAliases, liveswitchIconSet, LiveswitchIcon };
